import { render } from "./NewAdminForm.vue?vue&type=template&id=a4bd7c14"
import script from "./NewAdminForm.vue?vue&type=script&lang=js"
export * from "./NewAdminForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__